import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LoginScreen = () => {
  const [participantNumber, setParticipantNumber] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!participantNumber.trim()) {
      setError('Voer een deelnemersnummer in');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'https://api-teams-kvw-herten.ipg.nu';
      const response = await fetch(`${apiUrl}/api/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({
          participantNumber: participantNumber.trim()
        })
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Deelnemersnummer niet gevonden');
      }

      const data = await response.json();
      if (data.success) {
        navigate('/team');
      } else {
        throw new Error('Login mislukt');
      }
      
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      {/* KVW Logo */}
      <img src="/logo.jpeg" alt="KVW Logo" className="kvw-logo" />

      <div className="login-form">
        <h2>Teamindeling 2026</h2>
        <p>Voer je deelnemersnummer in die je per mail hebt ontvangen om je team te bekijken</p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            {/* <label htmlFor="participantNumber">Deelnemersnummer:</label> */}
            <input
              type="text"
              id="participantNumber"
              value={participantNumber}
              onChange={(e) => setParticipantNumber(e.target.value)}
              placeholder="Deelnemersnummer (bijv. D26-104 of J26-801)"
              disabled={loading}
            />
          </div>
          
          {error && <div className="error-message">{error}</div>}
          
          {loading && <div className="loading">Zoeken...</div>}
          
          <button 
            type="submit" 
            className="search-button"
            disabled={loading}
          >
            {loading ? 'Zoeken...' : 'Zoek Team'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginScreen;
